import React from "react";
import { Divider } from "antd";
import { useGet, usePost } from "../../common/hooks";
import { useEnsuredUser } from "../../common/contexts";
import { Game, GoalieAvailabilities } from "../../common/interfaces";
import { dtNow, nDaysFromNow } from "../../common/utils";
import _ from "lodash";
import { AttendanceTable } from "../../common/components/AttendanceTable";
import { G_SCHEDULE, G_AVAILABILITY } from "../routes";
import { Link } from "react-router-dom";

export function GoalieDashboard() {
  const user = useEnsuredUser();
  const assignedGames = useGet<Game[]>(
    user.goalieId ? `/api/games?goalieId=${user.goalieId}` : undefined
  );
  const availabilities = useGet<GoalieAvailabilities>(
    user.goalieId ? `/api/goalieAvailabilities?goalieId=${user.goalieId}` : undefined
  );
  const availabilityPostReq = usePost({
    uri: "/api/updateGoalieAvailability",
    deps: [availabilities]
  });

  const onAvailabilityClick = (row: Game, modifyType: string) => {
    availabilityPostReq.send({
      gameId: row.id,
      goalieId: user.goalieId,
      available: modifyType === "add"
    });
  };

  const twoWeeksFromNow = nDaysFromNow(14);
  const now = dtNow();

  const upcomingAssigned = _.sortBy(
    (assignedGames.data || []).filter(g => g.date >= now && g.date <= twoWeeksFromNow),
    g => g.date
  );

  const upcomingEligible = _.sortBy(
    (availabilities.data?.games || []).filter(g => g.date >= now && g.date <= twoWeeksFromNow),
    g => g.date
  );

  return (
    <>
      <Divider>Your Upcoming Games</Divider>
      <p>
        Below are your games in the next two weeks. Click{" "}
        <Link to={G_SCHEDULE}>here</Link> to view your full schedule.
      </p>
      {assignedGames.data && upcomingAssigned.length === 0 ? (
        <p>You have no games in the next two weeks.</p>
      ) : (
        <AttendanceTable
          games={assignedGames.data ? upcomingAssigned : undefined}
          isLoading={assignedGames.isLoading}
          showAttendanceButtons={false}
          onClick={() => undefined}
        />
      )}
      <Divider>Eligible Games in the Next Two Weeks</Divider>
      <p>
        Below are games you are eligible for in the next two weeks. Click{" "}
        <Link to={G_AVAILABILITY}>here</Link> to set your availability for the full season.
      </p>
      {availabilities.data && upcomingEligible.length === 0 ? (
        <p>You are not eligible for any games in the next two weeks.</p>
      ) : (
        <AttendanceTable
          games={availabilities.data ? upcomingEligible : undefined}
          isLoading={availabilityPostReq.isLoading || availabilities.isLoading}
          showAttendanceButtons={true}
          onClick={onAvailabilityClick}
          attendanceColLabel={"Available"}
        />
      )}
    </>
  );
}
